import React, { Component, Fragment } from "react";
import { Row, Col } from "reactstrap";
import "bootstrap-daterangepicker/daterangepicker.css";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";
import axios from "../../../axios-instance";
import Loader from "../../../components/Loader/Loader";
import { onModalOpen, onModalClose } from "../../../utils/utility";
import isEmpty from "../../../validation/is-empty";
import { dateRangeEvents } from "../../../actions/admin/scheduled-event-actions";
import { Pagination } from "antd";
import { connect } from "react-redux";
import UpcomingViewDetailsModal from "./upcoming-event-detail";
import PastViewDetails from "./past-view-details";
import { getAdminBusinessId, getLoggedInUserId } from "../../../utils/authHelper";
import { mapDatePickerFormatToMoment } from "../../../utils/eventConfigHelpers";
import ScheduledEventCard from "../../admin/schedule/scheduled-events/ScheduledEventCard";
import ScheduledDayGroup from "../../admin/schedule/scheduled-events/ScheduledDayGroup";

let staffCanCancel = "D";
let staffCanReschedule = "D";

class DateRange extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageLoading: false,
      events: [],
      totalEvents: 0,
      bookingId: null,
      pagination: {
        current: 1,
        pageSize: 5,
      },
      filter: {},
      startDate: "",
      endDate: "",
      showUpcomingEventDetail: false,
      showPastEventDetail: false,
      datePickerFormat: "MM/DD/YYYY",
    };
  }

  componentDidMount() {
    const businessId = getAdminBusinessId();
    if (!businessId) {
      return;
    }

    axios
      .get(`/admin/settings/event/${businessId}`)
      .then((res) => {
        const resData = res?.data || {};
        const config = resData?.data?.data || resData?.data || {};
        this.setState({
          datePickerFormat: mapDatePickerFormatToMoment(
            config.date_picker_format || "mm/dd/yyyy"
          ),
        });
      })
      .catch(() => {});
  }

  /**
   * hide view detail modal
   */
  hideViewDetailModal = () => {
    this.setState({
      showUpcomingEventDetail: false,
      showPastEventDetail: false,
    });
    onModalClose();
  };

  /**
   * prepare data parameters to be send to server
   * @param {*} params
   */
  prepareDataParam = (params) => {
    let sortField = "id";
    let sortOrder = "asc";

    if (!isEmpty(params.sortField) && !isEmpty(params.sortOrder)) {
      sortField = params.sortField;
      sortOrder = params.sortOrder === "ascend" ? "asc" : "desc";
    }

    return {
      pageSize: params.pagination.pageSize,
      pageNumber: params.pagination.current,
      sortField,
      sortOrder,
      filter: {
        staff_id: getLoggedInUserId(),
        ...params.filters,
      },
    };
  };

  /**
   * on page change
   * @param {*} page
   * @param {*} pageSize
   */
  onPageChange = (page, pageSize) => {
    const _this = this;
    _this.setState({
      pageLoading: true,
    });
    _this.fetchListEvents({
      pagination: {
        current: page,
        pageSize: pageSize,
      },
    });
  };

  /**
   * fetch list events
   */
  fetchListEvents = (params = {}) => {
    const _this = this;
    const { dateRangeEvents } = _this.props || {};
    dateRangeEvents({
      data: _this.prepareDataParam(params),
      onSuccess: function (response) {
        const { data, total, event_settings: eventSettings } = response;

        staffCanReschedule = eventSettings.staff_can_reschedule_booking;
        staffCanCancel = eventSettings.staff_can_cancel_booking;

        _this.setState({
          events: data,
          totalEvents: total,
          pageLoading: false,
          pagination: { ...params.pagination },
        });
      },
      onError: function (error) {
        console.error(error);
      },
    });
  };

  /**
   * on handle table change
   * @param {*} pagination
   * @param
   */
  handleTableChange = (pagination, filters, sorter) => {
    this.fetchListEvents({
      sortField: sorter.field,
      sortOrder: sorter.order,
      pagination,
      filters,
    });
  };

  /**
   * on filter records
   * @param {*} start date
   * @param {*} end date
   */
  onFilterDataTable = (startDate, endDate) => {
    this.setState({
      pageLoading: true,
    });

    this.handleTableChange(
      {
        ...this.state.pagination,
      },
      {
        start_date: startDate,
        end_date: endDate,
      },
      {}
    );
  };

  /**
   * on upcoming booking detail click
   * @param {*} bookingData
   */
  onUpcomingEventDetail = (bookingData) => {
    this.setState({
      bookingId: bookingData.id,
      showUpcomingEventDetail: true,
    });
  };

  /**
   * on past booking detail click
   * @param {*} bookingData
   */
  onPastEventDetail = (bookingData) => {
    this.setState({
      bookingId: bookingData.id,
      showPastEventDetail: true,
    });
  };

  render() {
    const {
      pageLoading,
      events,
      pagination,
      startDate,
      endDate,
      bookingId,
      showUpcomingEventDetail,
      showPastEventDetail,
      datePickerFormat,
    } = this.state || {};

    return (
      <>
        {showUpcomingEventDetail && (
          <UpcomingViewDetailsModal
            bookingId={bookingId}
            showViewDetailModal={showUpcomingEventDetail}
            handleClose={this.hideViewDetailModal}
            loadUpcomingEvents={() =>
              this.onFilterDataTable(startDate, endDate)
            }
            staffCanReschedule={staffCanReschedule}
            staffCanCancel={staffCanCancel}
          />
        )}

        {showPastEventDetail && (
          <PastViewDetails
            bookingId={bookingId}
            showViewDetailModal={showPastEventDetail}
            handleClose={this.hideViewDetailModal}
          />
        )}

        <Loader isShowLoader={pageLoading} />
        <div className="rd_pasevencontth">
          <DateRangePicker
            initialSettings={{
              startDate: moment(),
              endDate: moment().add(14, "d"),
              locale: {
                format: datePickerFormat,
              },
            }}
            onCallback={(start, end, label) => {
              const startDate = moment(start).format("yyyy-MM-DD");
              const endDate = moment(end).format("yyyy-MM-DD");

              this.setState({
                startDate,
                endDate,
              });

              this.onFilterDataTable(startDate, endDate);
            }}
          >
            <input type="text" className="mb-4" />
          </DateRangePicker>

          {Object.keys(events).length > 0 ? (
            <Fragment>
              {Object.keys(events).map((key, index) => (
                <ScheduledDayGroup key={index} dateKey={key}>
                  {(events[`${key}`] || []).map((event, innerIndex) => (
                    <ScheduledEventCard
                      key={innerIndex}
                      event={event}
                      cancelled={event.status === "CC"}
                      showRole={false}
                      onViewDetail={(ev) => {
                        onModalOpen();
                        ev.is_past_event === "E"
                          ? this.onPastEventDetail(ev)
                          : this.onUpcomingEventDetail(ev);
                      }}
                    />
                  ))}
                </ScheduledDayGroup>
              ))}
            </Fragment>
          ) : null}

          {Object.keys(events).length > 0 && (
            <Row className="pb-4 pr-md-3">
              <Col className="text-center" lg="12" md="12">
                <Pagination
                  className="list-view-pagination"
                  defaultCurrent={pagination.current}
                  current={pagination.current}
                  total={this.state.totalEvents}
                  pageSize={pagination.pageSize}
                  onChange={this.onPageChange}
                />
              </Col>
            </Row>
          )}
        </div>
      </>
    );
  }
}

export default connect(null, {
  dateRangeEvents,
})(DateRange);
